import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function SectionContainer({ className, children }) {
  return (
    <section className={classnames('container', className)}>
      {children}
      <style jsx>{styles}</style>
    </section>
  )
}

SectionContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

SectionContainer.defaultProps = {
  className: null,
  children: null,
}

SectionContainer = chainDecorators(decorators, SectionContainer)

export default SectionContainer
